import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { agentListEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

import {
  IAgentSummaryResponse,
  fetchAgentSummary,
  fetchAgentSummaryFailure,
  fetchAgentSummarySuccess,
} from '../../slice/agent/AgentSummary.slice';

export interface IAgentSummary {
  totalAgents: number;
  onlineAgents: number;
  capacityUtilization: number;
  unusedCapacity: number;
  unallocatedAgents: number;
  nilAllocatedAgents: number;
}

function* fetchAgentSummarySaga(action: PayloadAction<{ type: string }>) {
  try {
    const { type } = action.payload;
    let channel = 'ALL';
    if (type === 'callAgents') {
      channel = 'CALL';
    } else if (type === 'fieldAgents') {
      channel = 'FIELD';
    }
    const response: AxiosResponse<IAgentSummaryResponse> = yield call(
      HTTPClient.GetRequest,
      agentListEndpoints.GET_AGENT_DETAILS_LIST_SUMMARY(channel)
    );
    yield put(fetchAgentSummarySuccess(response.data));
  } catch (error: any) {
    yield put(
      fetchAgentSummaryFailure(
        error?.message || 'Failed to fetch agent summary'
      )
    );
    message.error('Failed to fetch agent summary');
  }
}

export function* watchAgentSummarySaga() {
  yield takeLatest(fetchAgentSummary.type, fetchAgentSummarySaga);
}
